import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Assignment from '@mui/icons-material/Assignment';
import { CollapseCard, FakeText } from '@totalsoft/rocket-ui';
import FacilityWarrantyComponent from './FacilityWarrantyComponent';
import { Table, TableBody, TableCell, TableHead, TableRow, Grid } from '@mui/material';
import CardNoResultsWrapper from 'components/layout/CardNoResultsWrapper';

const FacilityWarrantyCard = ({ facilityWarranties, loading, loaded }) => {
  const { t } = useTranslation();

  return (
    <CollapseCard icon={Assignment} title={t('Folder.GeneralData.Warranties.Title')} toggleOnHeaderClick>
      {loading && !loaded ? (
        <FakeText lines={6} />
      ) : (
        <Grid item xs={12}>
          <CardNoResultsWrapper content={facilityWarranties}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>{t('Folder.GeneralData.Warranties.WarrantyTypeName')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.GuarantorName')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.IssuerName')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.Amount')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.Currency')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.ValidFrom')}</TableCell>
                  <TableCell>{t('Folder.GeneralData.Warranties.ValidTo')}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {facilityWarranties &&
                  facilityWarranties.map((item, idx) => {
                    return <FacilityWarrantyComponent facilityWarranty={item} index={idx} key={idx} />;
                  })}
              </TableBody>
            </Table>
          </CardNoResultsWrapper>
        </Grid>
      )}
    </CollapseCard>
  );
};

FacilityWarrantyCard.propTypes = {
  facilityWarranties: PropTypes.array.isRequired,
  loading: PropTypes.bool,
  loaded: PropTypes.bool
};

export default FacilityWarrantyCard;
